export default class LanguagePackLoadedEvent {
    constructor(id, url, lpJson) {
        this.id = id;
        this.lpJson = lpJson;
        this.url = url;
    }
}

LanguagePackLoadedEvent.LOADED = "LanguagePackLoadedEvent.LOADED";